import React, { useState } from 'react';
import api from '../services/api';
import LoadingSpinner from './LoadingSpinner';

type PropTypes = {
    onStudyCreated: () => void;
};

function CreateStudyForm({ onStudyCreated }: PropTypes) {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        startDate: '',
        length: 0,
    });

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async () => {
        setLoading(true);
        const { success } = await api.createStudy(
            formData.name,
            formData.startDate,
            Number(formData.length),
        );
        setLoading(false);
        if (success) {
            onStudyCreated();
        }
    };

    return (
        <div className="w-[300px]">
            <form onSubmit={handleSubmit}>
                <div className="mt-2 flex items-center justify-between">
                    <label>Name:</label>
                    <input
                        className="border border-black rounded text-primary p-1 w-1/2"
                        type="text"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                    />
                </div>
                <div className="mt-2 flex items-center justify-between">
                    <label>Start Date:</label>
                    <input
                        className="border border-black rounded text-primary p-1 w-1/2"
                        type="date"
                        name="startDate"
                        value={formData.startDate}
                        onChange={handleChange}
                    />
                </div>
                <div className="mt-2 flex items-center justify-between">
                    <label>Length:</label>
                    <input
                        className="border border-black rounded text-primary p-1 w-1/2"
                        type="number"
                        name="length"
                        value={formData.length}
                        onChange={handleChange}
                    />
                </div>
                <button
                    type="submit"
                    className="btn btn-primary mt-6"
                    disabled={loading}
                >
                    {loading ? <LoadingSpinner size={30} /> : 'Create Study'}
                </button>
            </form>
        </div>
    );
}

export default CreateStudyForm;
